export default __webpack_public_path__ + "static/pay-banner-1-15f921d7f88f3cf4431fd3c46bde6f2e.jpeg";